let apiPromise = null;

function loadYoutubeIframeApi() {
  if (!apiPromise) {
    apiPromise = new Promise((resolve) => {
      if (window.YT && window.YT.Player) {
        resolve(window.YT);
        return;
      }
      window.onYouTubeIframeAPIReady = () => resolve(window.YT);
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    });
  }
  return apiPromise;
}

const STATE_EVENTS = {
  0: 'ended',
  1: 'playing',
  2: 'paused',
  3: 'buffering',
  5: 'cued',
};

export default {
  props: {
    playerHeight: {
      type: [String, Number],
      default: '360',
    },
    playerWidth: {
      type: [String, Number],
      default: '640',
    },
    playerVars: {
      type: Object,
      default: () => ({ autoplay: 0 }),
    },
    videoId: {
      type: String,
      default: null,
    },
    mute: {
      type: Boolean,
      default: false,
    },
    host: {
      type: String,
      default: 'https://www.youtube.com',
    },
  },
  data() {
    return {
      player: null,
      disposed: false,
    };
  },
  watch: {
    playerWidth() {
      this.setSize();
    },
    playerHeight() {
      this.setSize();
    },
    videoId(videoId) {
      this.updateVideo(videoId);
    },
    mute(value) {
      this.setMute(value);
    },
  },
  methods: {
    setSize() {
      if (this.player && this.player.setSize) {
        this.player.setSize(this.playerWidth, this.playerHeight);
      }
    },
    setMute(value) {
      if (!this.player) return;
      if (value) {
        this.player.mute();
      } else {
        this.player.unMute();
      }
    },
    updateVideo(videoId) {
      if (!this.player) return;
      const method = this.playerVars.autoplay ? 'loadVideoById' : 'cueVideoById';
      if (typeof this.player[method] === 'function') {
        this.player[method](videoId);
      }
    },
  },
  mounted() {
    loadYoutubeIframeApi().then((YT) => {
      if (this.disposed) return;
      this.player = new YT.Player(this.$refs.mountEl, {
        height: this.playerHeight,
        width: this.playerWidth,
        playerVars: this.playerVars,
        videoId: this.videoId,
        host: this.host,
        events: {
          onReady: (event) => {
            this.setMute(this.mute);
            this.$emit('ready', event);
          },
          onStateChange: (event) => {
            const name = STATE_EVENTS[event.data];
            if (name) this.$emit(name, event);
          },
          onError: (event) => {
            this.$emit('error', event);
          },
        },
      });
    });
  },
  beforeUnmount() {
    this.disposed = true;
    if (this.player && this.player.destroy) {
      this.player.destroy();
    }
    this.player = null;
  },
};
